import { render, staticRenderFns } from "./RiskIndex.vue?vue&type=template&id=2d681567&scoped=true"
import script from "./RiskIndex.vue?vue&type=script&lang=js"
export * from "./RiskIndex.vue?vue&type=script&lang=js"
import style0 from "./RiskIndex.vue?vue&type=style&index=0&id=2d681567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d681567",
  null
  
)

export default component.exports